import React from "react";
import { RouterGuard } from "react-router-guard";
import router from "./router";
import "./app.component.scoped.sass";
import { GlobalProvider } from "./store";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { ThemeProvider } from "@material-ui/core";

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

function App() {
  const theme = createMuiTheme({
    palette: {
      primary: { main: "#095db1" },
      secondary: { main: "#444" },
    },
  });
  return (
      <GlobalProvider>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <ThemeProvider theme={theme}>
            <div className="main-wrapper">
              <RouterGuard config={router} />
            </div>
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </GlobalProvider>
  );
}

export default App;
